import { BasePlugin } from '../base'
import {
  mdcTextSection,
  mdcText,
  mdcBody,
  mdcCaption,
  mdcDisplay,
  mdcHeadline,
  mdcSubHeading,
  mdcTitle
} from './mdc-typography.js'

export {
  mdcTextSection,
  mdcText,
  mdcBody,
  mdcCaption,
  mdcDisplay,
  mdcHeadline,
  mdcSubHeading,
  mdcTitle
}

export default BasePlugin({
  mdcTextSection,
  mdcText,
  mdcBody,
  mdcCaption,
  mdcDisplay,
  mdcHeadline,
  mdcSubHeading,
  mdcTitle
})
